export const DEFAULT_STALE_TIME_MS = 5 * 60 * 1000;
